import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage/session";
import { persistReducer } from "redux-persist";
import Reducers from "./Reducers";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: ["dashboard", "common"]
};

const persistedReducer = persistReducer(persistConfig, Reducers);

export default configureStore({
  reducer: persistedReducer,
  middleware: [thunk]
});
